import React from 'react';
import { ImageBackground, StyleSheet, View } from 'react-native';

import { AvatarModalPng, InviteBckd } from '../../../assets';
import { useDevice } from '../../../utils/hooks/useDevice';
import { TouchableOpacity } from '../common/Touchable';

const PlayerCard = () => {
	const { isDesktop, isMobile } = useDevice();
	const layout = isDesktop ? desktopLayout : mobileLayout;

	return (
		<TouchableOpacity activeOpacity={0.8} style={styles.touchable}>
			<ImageBackground
				source={InviteBckd}
				resizeMode='stretch'
				style={[styles.cardBackground, layout.cardBackground]}
			>
				<View style={[styles.container, layout.container]}>
					<View style={[styles.avatarWrapper, layout.avatarWrapper]}>
						<ImageBackground
							source={AvatarModalPng}
							style={[styles.avatar, layout.avatar, { width: isMobile ? 76 : 60 }]}
							resizeMode='contain'
						/>
					</View>
				</View>
			</ImageBackground>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	touchable: {
		borderRadius: 12,
	},
	cardBackground: {
		borderRadius: 12,
		marginBottom: 6,
		marginLeft: 16,
		height: 52,
	},
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatarWrapper: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		position: 'relative',
	},
});

const mobileLayout = StyleSheet.create({
	cardBackground: { paddingRight: 12 },
	container: { gap: 8, marginLeft: 8 },
	avatarWrapper: { width: 110, marginLeft: -36 },
	avatar: { height: 56, left: -14, top: 0 },
});

const desktopLayout = StyleSheet.create({
	cardBackground: { paddingRight: 0 },
	container: { gap: 10, marginLeft: 6 },
	avatarWrapper: { width: 120, marginLeft: -10 },
	avatar: { height: 60, left: -38, top: -5 },
});

export default PlayerCard;
